import type { Language } from '../types.ts';

/**
 * Password vocabulary (GDD §8.6): noir/heist words of 5 and 6 letters, upper case, without
 * accents. A game uses one language for its whole vocabulary (GDD §16, item 23).
 */

export type WordCategory = 'place' | 'tool' | 'person' | 'loot' | 'vice';

export interface VocabWord {
  w: string;
  cat: WordCategory;
}

const list = (cat: WordCategory, words: string): VocabWord[] =>
  words.split(' ').map((w) => ({ w, cat }));

const EN5: VocabWord[] = [
  ...list('place', 'VAULT LOBBY ALLEY TRAIN HOTEL'),
  ...list('tool', 'ALARM LASER WIRES LATCH DRILL'),
  ...list('person', 'GUARD THIEF MAYOR'),
  ...list('loot', 'JEWEL PEARL CROWN'),
  ...list('vice', 'CIGAR BRIBE CARDS'),
];

const EN6: VocabWord[] = [
  ...list('place', 'BRIDGE CASINO HARBOR TUNNEL CELLAR GARAGE'),
  ...list('tool', 'CAMERA SIGNAL CIPHER HAMMER LADDER'),
  ...list('person', 'DRIVER DEALER LAWYER WAITER BANKER'),
  ...list('loot', 'LOCKET SILVER BRONZE RUBIES'),
  ...list('vice', 'WHISKY GAMBLE'),
];

const IT5: VocabWord[] = [
  ...list('place', 'BANCA ATRIO PORTO TRENO VILLA'),
  ...list('tool', 'LASER SCALA CORDA BORSA MAPPA'),
  ...list('person', 'LADRO CONTE SOCIO SERVO CUOCO'),
  ...list('loot', 'PERLA GEMME GIADA ONICE OPALE'),
  ...list('vice', 'POKER GIOCO VIZIO RISSA'),
];

const IT6: VocabWord[] = [
  ...list('place', 'VICOLO PIAZZA SALONE TUNNEL CAVEAU LAGUNA'),
  ...list('tool', 'CHIAVE GANCIO SIRENE CAMERA TELAIO'),
  ...list('person', 'BARONE NOTAIO SPIONE'),
  ...list('loot', 'RUBINO CORONA TESORO DENARO'),
  ...list('vice', 'SIGARO GRAPPA'),
];

export const VOCAB: Record<Language, Record<5 | 6, VocabWord[]>> = {
  en: { 5: EN5, 6: EN6 },
  it: { 5: IT5, 6: IT6 },
};
